import {createAction, props} from '@ngrx/store';
import {ExportJobPageDTO} from '../../openapi/export-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class ErrorEventEntitiesActions {

  private static readonly prefix = '[Error Event Entities]';

  public static loadErrorEvents = createAction(
    `${this.prefix} Load Error Events`,
    props<{
      exportConfigId: string;
      pageIndex: number;
      pageSize: number;
    }>(),
  );

  public static loadErrorEventsSuccess = createAction(
    `${this.prefix} Load Error Events Success`,
    props<{
      page: ExportJobPageDTO;
      exportConfigId: string;
    }>(),
  );

  public static loadErrorEventsFailure = createAction(
    `${this.prefix} Load Error Events Failure`,
    props<{
      error: MappedHttpErrorResponse;
      exportConfigId: string;
    }>(),
  );

}
